import axiosInstance from './axiosInstance';

export const GetAllVendorsByStore = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/Vendor/StoreId/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetVendListByStore = async (store_id) => {
  try {
    const { data } = await axiosInstance.get(`/vendor/list/${store_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const DeleteVendor = async (vendor_id) => {
  try {
    const { data } = await axiosInstance.delete(`/Vendor/${vendor_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const AddVendorApi = async (
  store_id,
  name,
  phone,
  website,
  contact_name,
  contact_phone,
  contact_email,
  opening_balance,
  term_id,
  r_street,
  r_city,
  r_state,
  r_zip,
  r_country,
  r_phone,
  s_street,
  s_city,
  s_state,
  s_zip,
  s_country,
  attention_name,
  s_phone,
  note
) => {
  try {
    const { data } = await axiosInstance.post(`/Vendor`, {
      store_id: store_id,
      name: name,
      phone: phone,
      website: website,
      contact_name: contact_name,
      contact_phone: contact_phone,
      contact_email: contact_email,
      term_id: term_id,
      balance: opening_balance,
      remitting_address: {
        street: r_street,
        city: r_city,
        state: r_state,
        zip: r_zip,
        country: r_country,
        phone: r_phone,
      },
      shipping_address: {
        street: s_street,
        city: s_city,
        state: s_state,
        zip: s_zip,
        country: s_country,
        attention_name: attention_name,
        phone: s_phone
      },
      notes: note,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditVendorApi = async (
  vendor_id,
  store_id,
  name,
  phone,
  website,
  contact_name,
  contact_phone,
  contact_email,
  term_id,
  opening_balance,
  r_street,
  r_city,
  r_state,
  r_zip,
  r_country,
  r_phone,
  s_street,
  s_city,
  s_state,
  s_zip,
  s_country,
  attention_name,
  s_phone,
  note
) => {
  try {
    const { data } = await axiosInstance.put(`/Vendor/${vendor_id}`, {
      store_id: store_id,
      name: name,
      phone: phone,
      website: website,
      contact_name: contact_name,
      contact_phone: contact_phone,
      contact_email: contact_email,
      term_id: term_id,
      balance: opening_balance,
      remitting_address: {
        street: r_street,
        city: r_city,
        state: r_state,
        zip: r_zip,
        country: r_country,
        phone: r_phone,
      },
      shipping_address: {
        street: s_street,
        city: s_city,
        state: s_state,
        zip: s_zip,
        country: s_country,
        attention_name: attention_name,
        phone: s_phone
      },
      notes: note
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const GetVendorById = async (vendor_id) => {
  try {
    const { data } = await axiosInstance.get(`/Vendor/id/${vendor_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
